<template>
  <section
    class="hero is-bold app-navbar animated"
    :class="{ slideInDown: show, slideOutDown: !show }"
  >
    <div class="hero-head">
      <nav class="navbar">
        <div class="navbar-brand">
          <a
            class="navbar-item is-hidden-tablet"
            @click="toggleSidebar({opened: !sidebar.opened})"
          >
            <i
              v-show="!sidebar.hidden"
              class="fa fa-bars"
              aria-hidden="true"
            />
          </a>
          <a
            class="navbar-item hero-brand"
            href="/"
          >
            <img
              src="~assets/logo.png"
              alt="KAI"
            >
          </a>
        </div>
        <div class="navbar-menu">
          <div
            v-if="appEnvironment"
            class="navbar-item environment"
          >
            {{ appEnvironment }}
          </div>
          <div class="navbar-end is-flex">
            <div class="navbar-item">
              <div class="selectedInfo">
                <div v-if="onderzoek.inventarisatie_asset && project">
                  <span v-t="'project'" />
                  {{ onderzoek.project && onderzoek.project.nummer }}: {{ onderzoek.inventarisatie_asset.asset.straatnaam + ' ' + onderzoek.inventarisatie_asset.asset.huisnummer }}
                </div>
              </div>
            </div>
            <div class="navbar-item">
              <div class="level">
                <select
                  v-model="$i18n.locale"
                  class="level-item"
                >
                  <option disabled>
                    Language
                  </option>
                  <option value="nl">
                    NL
                  </option>
                  <option value="en">
                    EN
                  </option>
                  <option value="fr">
                    FR
                  </option>
                  <option value="de">
                    DE
                  </option>
                </select>
              </div>
            </div>
            <div class="navbar-item">
              <avatar
                v-if="$auth.check()"
                :size="40"
                :username="$auth.user().name"
              />
            </div>
            <a
              v-if="!$auth.check()"
              class="navbar-item"
              @click="login"
            >Login</a>
            <a
              v-else
              class="navbar-item"
              @click="logout"
            >Uitloggen</a>
            <div
              class="navbar-item"
              @click="openChangelogModal"
            >
              v{{ version }}
            </div>
          </div>
        </div>
      </nav>
    </div>
    <changelog
      v-if="showChangelogModal"
      :show.sync="showChangelogModal"
    />
  </section>
</template>

<script>
import Avatar from 'vue-avatar'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import packageInfo from '../../../package.json'
import Changelog from './Changelog'

export default {
  components: {
    Avatar,
    Changelog
  },
  props: {
    show: Boolean
  },
  data () {
    return {
      version: packageInfo.version,
      showChangelogModal: false
    }
  },
  computed: {
    ...mapGetters({
      pkginfo: 'pkg',
      sidebar: 'sidebar'
    }),
    ...mapState({
      project: state => state.projectmanagement.project,
      onderzoek: state => state.projectmanagement.onderzoek,
      language: state => state.language
    }),
    appEnvironment () {
      const environment = process.env.APP_ENV
      if (!environment) return null
      if (environment.toLowerCase() === 'production') return null
      return environment
    }
  },
  methods: {
    ...mapMutations([
      'RESET_RAPPORTAGE_STATE',
      'RESET_INVENTARISATIE_STATE',
      'RESET_MANAGEMENT_STATE',
      'RESET_PROJECTMANAGEMENT_STATE',
      'RESET_VASTGOED_STATE'
    ]),
    ...mapActions([
      'toggleSidebar'
    ]),
    login () {
      this.$auth.oauth2({
        provider: 'kiwa'
      })
      this.RESET_RAPPORTAGE_STATE()
      this.RESET_INVENTARISATIE_STATE()
      this.RESET_MANAGEMENT_STATE()
      this.RESET_PROJECTMANAGEMENT_STATE()
      this.RESET_VASTGOED_STATE()
    },
    logout () {
      this.$auth.logout({
        redirect: '/login',
        makeRequest: true,
        method: 'POST',
        success: () => {
          this.RESET_RAPPORTAGE_STATE()
          this.RESET_INVENTARISATIE_STATE()
          this.RESET_MANAGEMENT_STATE()
          this.RESET_PROJECTMANAGEMENT_STATE()
          this.RESET_VASTGOED_STATE()
          this.$localStorage.set('access_token', false)
          this.$router.push('login')
        },
        error: (error) => {
          this.RESET_RAPPORTAGE_STATE()
          this.RESET_INVENTARISATIE_STATE()
          this.RESET_MANAGEMENT_STATE()
          this.RESET_PROJECTMANAGEMENT_STATE()
          this.RESET_VASTGOED_STATE()
          this.$localStorage.set('access_token', false)
          this.$router.push('login')
          console.warn('logout should not return redirect', error)
        }
      })
    },
    openChangelogModal () {
      this.showChangelogModal = true
    }
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/_all';
@import '~styles/variables.scss';

.app-navbar {
  position: fixed;
  min-width: 100%;
  background-color: white;
  z-index: 1024;

  .navbar-menu {
    box-shadow: 0px 1px 0px rgba(17, 17, 17, 0.1), 1px 0px 0 1px rgba(17, 17, 17, 0.1);
    // border-bottom:  1px solid rgba(90, 97, 105, 0.12);

    .environment {
      font-weight: bold;
      color: rgb(207, 20, 37);
    }
  }

  .container {
    margin: auto 10px;
  }

  .nav-right {
    align-items: stretch;
    flex: 1;
    justify-content: flex-end;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
  }
}

.selectedInfo {
  div {
    display: block;
  }
}

.navbar-item.hero-brand {
  width: $sidebar-width;
  padding: 0;
  padding-left: 0.5rem;
  img {
    margin-right: 0;
    max-height: 49px;
  }
}
</style>
